import initialState from 'src/store/state'
import { timeout } from 'src/scripts/utilities'

// Target State
const moduleState = initialState.talk

// Actions
const ADD_TALK = 'ADD_TALK'
const CLEAR_TALK = 'CLEAR_TALK'

// Action Creators
export const addTalk = (data:object, delay:number = 0) => async (dispatch) => {
  await timeout(delay)
  dispatch({
    type: ADD_TALK,
    payload: { data }
  })
}

export const clearTalk = (delay:number = 0) => async (dispatch) => {
  await timeout(delay)
  dispatch({
    type: CLEAR_TALK,
    payload: {}
  })
}

// Reducers
const reducers = (state = moduleState, action:any) => {
  switch (action.type) {
    case ADD_TALK:
      return Object.assign({}, state, {
        history: [...state.history, { ...action.payload.data }]
      })

    case CLEAR_TALK:
      return Object.assign({}, state, {
        history: moduleState.history
      })

    default:
      return state
  }
}

export default reducers
